/*
 * Build flag for the account-level "Ticket Credit" section on Profile (the
 * Apex postponement retention credit: single-use code worth 50% of spend, 12
 * months, locked to the purchaser's email — the ruling is that it must be
 * visible on each user's account). Same shape as legacyHistoryEnabled /
 * transferEnabled: the section renders ONLY when
 * VITE_TICKET_CREDITS_ENABLED === 'true' — absent or anything else = OFF,
 * which is correct for stage and prod with zero env changes until my-api's
 * GET /me/ticket-credits ships there. The env is injectable so tests can pin
 * both sides.
 */
export function ticketCreditsEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_TICKET_CREDITS_ENABLED === 'true'
}
